import { render, staticRenderFns } from "./DropshipperDeleteItemModal.vue?vue&type=template&id=5752dd35&scoped=true"
import script from "./DropshipperDeleteItemModal.vue?vue&type=script&lang=js"
export * from "./DropshipperDeleteItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752dd35",
  null
  
)

export default component.exports